import { Content } from "antd/es/layout/layout";
import React from "react";
import AllJobs from "./AllJobs";
import { Flex, Pagination as AntdPagination } from "antd";
import { JobDescription } from "../../../Entities/job-description.entity";
import { findAllJobPostDto, Pagination } from "../../../Interface/Index";

interface JobPostListingProps {
  type: "all-job-post" | "applied-job-post";
  appliedJobPostIds: string[];
  jobDescriptions: JobDescription[];
  handleViewDetails: (id: string) => void;
  handleApply: (id: string) => void;
  handlePageChange: (page: number) => void;
  filters: findAllJobPostDto;
  pagination: Pagination;
}

const JobPostListing: React.FC<JobPostListingProps> = ({
  type,
  appliedJobPostIds,
  jobDescriptions,
  handleViewDetails,
  handleApply,
  filters,
  handlePageChange,
  pagination,
}) => {
  const isListingAllJobPost = type === "all-job-post";

  const jobDescriptionsToList = isListingAllJobPost
    ? jobDescriptions
    : jobDescriptions.filter((job) => appliedJobPostIds.includes(job._id));
  return (
    <Content>
      <div className="job_card_listing_container">
        <AllJobs
          appliedJobIds={appliedJobPostIds}
          jobDescriptions={jobDescriptionsToList}
          handleViewDetails={handleViewDetails}
          handleApply={handleApply}
        />
      </div>
      <Flex justify="flex-end" style={{  marginTop: 16}}>
        {pagination?.page && (
          <AntdPagination
            current={filters.page || 1}
            pageSize={filters.limit || 10}
            total={pagination.total || 0}
            onChange={handlePageChange}
          />
        )}
      </Flex>
    </Content>
  );
};

export default JobPostListing;
